import useSWR, { useSWRConfig } from 'swr';
// import useSWRMutation from 'swr/mutation';

import { getCaseToGrade } from '@/api/cases';
import { ENDPOINTS } from '@/api/endpoints';

// Infer the resolved type of the response from the getCases function
type GetCasesResponse = Awaited<ReturnType<typeof getCaseToGrade>>;

type GetCaseForGradeProps = {
  caseId?: string;
};

export const useGetCaseForGrade = ({ caseId }: GetCaseForGradeProps) => {
  const _key = getCaseKey(caseId);
  const fetcher = (key: [string, string]) => getCaseToGrade(key[1]);

  const { data, error, isLoading, mutate } = useSWR<GetCasesResponse, Error>(_key, fetcher, {
    revalidateOnFocus: false,
  });

  return {
    error,
    response: data,
    data: data?.data,
    loading: isLoading,
    refetch: mutate,
  };
};

export const useRefreshCaseForGrade = (caseId?: string) => {
  const { mutate } = useSWRConfig();
  const _key = getCaseKey(caseId);

  return { refresh: () => mutate(_key) };
};

const getCaseKey = (caseId?: string) => {
  return caseId ? [ENDPOINTS.CASE.replace('{caseId}', caseId), caseId] : null;
};
